import React, { useEffect } from 'react'
import { Card } from 'primereact/card'
import _ from 'lodash'
import './ContratoForm.scss'
import '../../../index.scss'
import LtsInputText from '../../../components/lottus/lts-input-text'

export default function InformacoesDebitoAutomatico(props) {
  useEffect(() => {}, [props.plano.formaPagamento])

  return (
    <React.Fragment>
      <Card subTitle={'Informações para débito automático'}>
        <div className="p-grid form-group">
          <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
            <LtsInputText
              value={_.get(props, 'plano.codigoAgencia', '')}
              label={'Agência'}
              onChange={(e) => props.setField('codigoAgencia', e)}
              style={{ minWidth: '300px', maxWidth: '300px' }}
            />
          </div>
        </div>
        <div className="p-grid form-group">
          <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
            <LtsInputText
              value={_.get(props, 'plano.codigoConta', '')}
              label={'Conta'}
              onChange={(e) => props.setField('codigoConta', e)}
              style={{ minWidth: '300px', maxWidth: '300px' }}
            />
          </div>
        </div>
      </Card>
    </React.Fragment>
  )
}
